import { GithubAuthDataService } from '../../../github-auth-data.service';
import { GithubTokensService } from '../../../github-tokens.service';
import { GithubAuthService } from '../../github-auth.service';
import { inject } from '@angular/core';
import {
  CustomMessageListener,
  LuigiCoreService,
} from '@openmfp/portal-ui-lib';

export abstract class GithubTokenMessageListenerService
  implements CustomMessageListener
{
  protected abstract readonly domain: string;

  private githubAuthService: GithubAuthService = inject(GithubAuthService);
  private githubAuthDataService: GithubAuthDataService = inject(
    GithubAuthDataService,
  );
  private luigiCoreService: LuigiCoreService = inject(LuigiCoreService);
  private githubTokensService: GithubTokensService =
    inject(GithubTokensService);

  messageId(): string {
    return `token.request.${this.domain}`;
  }

  async onCustomMessageReceived(): Promise<void> {
    await this.githubAuthService.executeGithubAuthFlowIfRequired(this.domain);
    await this.githubAuthDataService.readGithubAuthData();
    await this.githubTokensService.reloadGitHubTokensIntoLuigiGlobalContext();
    this.luigiCoreService.configChanged('navigation.nodes');
  }
}
